interface Substitution {
  expression: RegExp;
  placeholder: string;
}

const idUrlSubstitution: Substitution = {
  expression: /\d+/g,
  placeholder: '_id_',
};

export const tokenUrlSubstitution: Substitution = {
  expression: /[A-Za-z0-9_-]{43}/g,
  placeholder: '_token_',
};

export const uuidUrlSubstitution: Substitution = {
  expression:
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g,
  placeholder: '_uuid_',
};

/**
 * Important that tokenUrlSubstitiuon before id UrlSubstition,
 * because there are possible id's inside the tokens.
 */
const preDefinedUrlSubstitutions = [
  tokenUrlSubstitution,
  uuidUrlSubstitution,
  idUrlSubstitution,
];

export const subsituteIdsWithPlacedholders = (path: string): string => {
  return applySubstitutions(path, preDefinedUrlSubstitutions);
};

export const applySubstitutions = (
  string: string,
  substitutions: Substitution[]
): string => {
  return substitutions.reduce(
    (stringWithAccumulatedAppliedSubstitutions, substitution) =>
      substitution.expression[Symbol.replace](
        stringWithAccumulatedAppliedSubstitutions,
        substitution.placeholder
      ),
    string
  );
};

const SIGNATURE_RESULT_QUERY_PARAM_NAME = 'signature_result';
const PAYMENT_RESULT_QUERY_PARAM_NAME = 'payment_result';

export const getCurrentUrlWithAnonymizedQueryParams = () => {
  const queryParams = new URLSearchParams(window.location.search);

  if (queryParams.size === 0) {
    return `${window.location.hostname}${window.location.pathname}`;
  }

  const queryParamsWhitelist = [
    SIGNATURE_RESULT_QUERY_PARAM_NAME,
    PAYMENT_RESULT_QUERY_PARAM_NAME,
  ];

  queryParams.forEach((_value, key) => {
    if (!queryParamsWhitelist.includes(key)) {
      queryParams.set(key, 'anonymized');
    }
  });

  return `${window.location.hostname}${
    window.location.pathname
  }?${queryParams.toString()}`;
};
